const BASE_URL = process.env.REACT_APP_API_URL || "https://lerna.3devsnet.com/api/routes";

export default BASE_URL;


//Hostinger: https://lerna.3devsnet.com/api/routes
//Local: http://localhost:3001/routes



//local: admin 1234
//hostinger: admin 1

//cd backend, php -S 127.0.0.1:3001 -t .

// npx playwright test --project=chromium --workers=1 --reporter=list
